"use client";
import { jsxs as c, jsx as e } from "react/jsx-runtime";
const t = ({
  title: l,
  titleId: r,
  desc: i,
  descId: a,
  ...s
}) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": a,
    ...s,
    children: [
      i ? /* @__PURE__ */ e("desc", { id: a, children: i }) : null,
      l ? /* @__PURE__ */ e("title", { id: r, children: l }) : null,
      /* @__PURE__ */ e("path", { d: "M256 0c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135S330.439 0 256 0M423.966 358.195C387.006 320.667 338.009 300 286 300h-60c-52.008 0-101.006 20.667-137.966 58.195C51.255 395.539 31 444.833 31 497c0 8.284 6.716 15 15 15h420c8.284 0 15-6.716 15-15 0-52.167-20.255-101.461-57.034-138.805" })
    ]
  }
);
export {
  t as default
};
